import React from "react";
import { DefaultLinkFactory } from "@projectstorm/react-diagrams";
import CustomLinkWidget from "./CustomLinkWidget";
import CustomLinkModel from "./CustomLinkModel";

export default class CustomLinkFactory extends DefaultLinkFactory {
  constructor() {
    super("custom-link");
  }

  generateModel() {
    return new CustomLinkModel({ engine: this.engine });
  }

  generateReactWidget(event) {
    return <CustomLinkWidget link={event.model} diagramEngine={this.engine} />;
  }
}
